import { Thread } from "../../../../types"
import { initialMsgNotReplied } from "../../../utils"
import Badge from "../../badge"
import If from "../../if"
import Tooltip from "../../tool-tip"
import AfterHoursBadge from "./after-hours"

const ThreadStatus = ({ thread }: { thread: Thread }): JSX.Element => {
  if (thread.status === "disabled")
    return (
      <span>
        ⛔<i className="sr-only">Thread Disabled</i>
      </span>
    )

  if (thread.status === "deleted") return <Badge.Warning>Deleted</Badge.Warning>
  if (thread.status === "takeover") return <Badge.Info>Takeover</Badge.Info>

  return <></>
}

interface Props {
  thread: Thread
}

const Badges = ({ thread }: Props) => {
  const notReplied = initialMsgNotReplied(thread)

  let dashClickedCount = 0

  // Loop the events and find if summary sent
  thread.events.forEach(event => {
    const dashClicked = event.type === "dashboard_link_clicked"
    if (dashClicked) {
      dashClickedCount++
    }
    return dashClicked
  })

  const hasImmediateCall = thread.events.some(
    event => event.type === "immediate_call"
  )
  const hasScheduledCall = thread.events.some(
    event => event.type === "scheduled_call"
  )

  let countLiItems = 0

  if (dashClickedCount > 0) {
    countLiItems++
  }
  if (hasScheduledCall) {
    countLiItems++
  }
  if (hasImmediateCall) {
    countLiItems++
  }

  return (
    <div className="flex items-center gap-1 mt-2">
      <If
        condition={notReplied}
        then={<Badge.Danger>Not Replied</Badge.Danger>}
        elseCondition={thread.status === "scheduled"}
        else={<AfterHoursBadge />}
        default={<Badge.Success>Replied</Badge.Success>}
      />
      <ThreadStatus thread={thread} />

      <If
        condition={countLiItems > 0}
        then={
          <Tooltip
            toolTipNode={<span>🔥 {countLiItems}+</span>}
            text={
              <ul className="text-[10px]">
                <If
                  condition={dashClickedCount > 0}
                  then={
                    <li>
                      <span className="inline-block mr-1 -rotate-90">🧲</span>{" "}
                      Dash link clicked {dashClickedCount}x
                    </li>
                  }
                />
                <If
                  condition={hasScheduledCall}
                  then={
                    <li>
                      <span className="inline-block mr-1">🗓️</span> Scheduled
                      call
                    </li>
                  }
                />
                <If
                  condition={hasImmediateCall}
                  then={
                    <li>
                      <span className="inline-block mr-1">☎</span> Immediate
                      Call
                    </li>
                  }
                />
              </ul>
            }
            placement="top"
          />
        }
      />
    </div>
  )
}

export default Badges
